import React from "react";
import PropTypes from "prop-types";
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Grid,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { Add, Refresh, WhatsApp } from "@mui/icons-material";

export default function HeaderWhatsapp({
  onRefresh,
  onCreateClick,
  loading,
  filtros,
  onFiltroChange,
  gruposNOC,
  onClearFilters,
}) {
  const tags = [
    filtros.busqueda && ["busqueda", `Búsqueda: ${filtros.busqueda}`, ""],
    filtros.activo !== "todos" && [
      "activo",
      filtros.activo === "activos" ? "Activos" : "Inactivos",
      "todos",
    ],
    filtros.pulso !== "todos" && [
      "pulso",
      filtros.pulso === "conPulso" ? "Con pulso" : "Sin pulso",
      "todos",
    ],
    filtros.grupo !== "todos" && ["grupo", `Grupo NOC: ${filtros.grupo}`, "todos"],
  ].filter(Boolean);
  const toggle = (field, label, items, color, bg) => (
    <Box>
      <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#526b80", mb: 1 }}>
        {label}
      </Typography>
      <ToggleButtonGroup
        fullWidth
        exclusive
        value={filtros[field]}
        onChange={(_, value) => {
          if (value !== null) onFiltroChange(field, value);
        }}
        sx={{
          "& .MuiToggleButton-root": {
            minHeight: 48,
            fontSize: 13,
            textTransform: "none",
            color: "#506b80",
          },
          "& .MuiToggleButton-root.Mui-selected, & .MuiToggleButton-root.Mui-selected:hover": {
            bgcolor: bg,
            color,
            borderColor: `${color}70`,
            fontWeight: 700,
          },
        }}
      >
        {items.map(([value, name]) => (
          <ToggleButton key={value} value={value}>
            {name}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
  return (
    <Box sx={{ border: "1px solid #dce5ed", borderRadius: 3, overflow: "hidden", bgcolor: "#fff" }}>
      <Box
        sx={{
          p: 2.5,
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          flexWrap: "wrap",
          background: "linear-gradient(110deg, #193d50, #117565)",
          color: "#fff",
        }}
      >
        <WhatsApp />
        <Box sx={{ flex: 1, minWidth: 180 }}>
          <Typography variant="h5" sx={{ color: "#fff", fontWeight: 700 }}>
            WhatsApp de Jarvis
          </Typography>
          <Typography sx={{ color: "#d3e9e2", fontSize: 13 }}>
            Configuraciones por comercio, terminal y grupo
          </Typography>
        </Box>
        <Button
          startIcon={<Refresh />}
          disabled={loading}
          onClick={onRefresh}
          sx={{ "&&": { color: "#fff", border: "1px solid #86b6a9" } }}
        >
          Actualizar
        </Button>
        <Button
          startIcon={<Add />}
          disabled={loading}
          onClick={onCreateClick}
          sx={{
            "&&": { bgcolor: "#dff4e9", color: "#1b5c49" },
            "&&:hover": { bgcolor: "#ccebdc" },
          }}
        >
          Agregar configuración
        </Button>
      </Box>
      <Grid
        container
        spacing={2}
        sx={{
          p: 2.5,
          "& .MuiInputBase-root": { minHeight: 52, fontSize: 14, color: "#25475c" },
          "& .MuiInputLabel-root": { color: "#526b80" },
        }}
      >
        <Grid item xs={12} md={7}>
          <TextField
            fullWidth
            label="Buscar comercio, ID, terminal, grupo o workflow"
            value={filtros.busqueda}
            onChange={(e) => onFiltroChange("busqueda", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <Autocomplete
            options={gruposNOC}
            value={filtros.grupo === "todos" ? null : filtros.grupo}
            onChange={(_, value) => onFiltroChange("grupo", value || "todos")}
            renderInput={(params) => (
              <TextField {...params} label="Grupo NOC" placeholder="Todos los grupos" />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          {toggle(
            "activo",
            "Estado de la configuración",
            [
              ["todos", "Todos"],
              ["activos", "Activos"],
              ["inactivos", "Inactivos"],
            ],
            "#206346",
            "#def3e8"
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          {toggle(
            "pulso",
            "Pulso",
            [
              ["todos", "Todos"],
              ["conPulso", "Con pulso"],
              ["sinPulso", "Sin pulso"],
            ],
            "#51479c",
            "#eae6fc"
          )}
        </Grid>
      </Grid>
      {tags.length > 0 && (
        <Box
          sx={{ px: 2.5, pb: 2, display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}
        >
          <Typography sx={{ fontSize: 12, color: "#60788b" }}>Filtros aplicados:</Typography>
          {tags.map(([key, label, reset]) => (
            <Chip
              key={key}
              label={label}
              size="small"
              onDelete={() => onFiltroChange(key, reset)}
              sx={{ bgcolor: "#e9f3ef", color: "#20634e", fontWeight: 600 }}
            />
          ))}
          <Button onClick={onClearFilters} sx={{ "&&": { color: "#245e89" } }}>
            Limpiar todos
          </Button>
        </Box>
      )}
    </Box>
  );
}
HeaderWhatsapp.propTypes = {
  onRefresh: PropTypes.func.isRequired,
  onCreateClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  filtros: PropTypes.object.isRequired,
  onFiltroChange: PropTypes.func.isRequired,
  gruposNOC: PropTypes.array.isRequired,
  onClearFilters: PropTypes.func.isRequired,
};
